<template>
  <div
    v-if="PRODUCTS.length"
    class="product-gallery-recently-viewed"
  >
    <product-gallery
      title="Просмотренные товары"
      :products="PRODUCTS"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ProductGallery from '@/components/product-gallery/product-gallery.vue';
import { ROUTE_NAMES } from '@/router/route-names';
import { productGtmEvents } from '@/gtm/product';
import { createGtmEventsProxy } from '@/gtm/gtm-events-utils';

export default {
  components: {
    ProductGallery
  },

  provide() {
    const gtmEvents = {
      [ROUTE_NAMES.Product]: productGtmEvents.recentlyViewed,
    }[this.$route?.name];

    return {
      gtmEvents: createGtmEventsProxy(gtmEvents),
    };
  },

  data() {
    return {
      isInited: false,
    }
  },

  computed: {
    ...mapState('productGalleries', {
      PRODUCTS: state => state.recentlyViewed
    }),
  },

  mounted() {
    // если изначально компонент был скрыт, то при последующей отрисовке на фронте не загрузит данные
    if (!this.$isServer && !this.isInited) {
      this.isInited = true;
      this.loadRecentlyViewed();
    }
  },

  methods: {
    ...mapActions('productGalleries', ['loadRecentlyViewed'])
  },

  serverPrefetch () {
    this.isInited = true;
    return this.loadRecentlyViewed();
  },
}
</script>
